const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { file: fileApi } = require('@doctoroncallcom/api')

const {
  GET_FILE_ADMIN,
  // For Admin Panel - Getting file and pushing into array
  GET_FILE_AND_APPEND_ADMIN,
  // For Users - Getting file and pushing into array
  GET_FILE_AND_APPEND_USER,
  GET_FILES_URL_ADMIN,
  UPLOAD_FILES_ADMIN,

  GET_FILE,
  GET_FILE_TWO,
  GET_MULTIPLE_FILE,
  UPLOAD_FILES,
  GET_FILES_URL,
  GET_MC_FILE,
  GET_REFERRAL_FILE,
  GET_PRESCRIPTION_FILE,
} = require('./constants')

const {
  getFileAdminSuccess,
  getFileAdminError,
  // For Admin Panel - Getting file and pushing into array
  getFileAndAppendAdminSuccess,
  getFileAndAppendAdminError,
  // For Users - Getting file and pushing into array
  getFileAndAppendUserSuccess,
  getFileAndAppendUserError,

  uploadFilesAdminSuccess,
  uploadFilesAdminError,
  getUploadFilesUrlAdminSuccess,
  getUploadFilesUrlAdminError,

  getFileSuccess,
  getFileError,
  getFileTwoSuccess,
  getFileTwoError,
  getMultipleFileSuccess,
  getMultipleFileError,
  uploadFilesSuccess,
  uploadFilesError,
  getUploadFilesUrlSuccess,
  getUploadFilesUrlError,

  getMCFileSuccess,
  getMCFileError,
  getReferralFileSuccess,
  getReferralFileError,
  getPrescriptionFileSuccess,
  getPrescriptionFileError,
} = require('./actions')

const getFileAdminEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_FILE_ADMIN),
  mergeMap(action => fileApi.getFileAdminApi(api, action.payload.id)
    .then(response => getFileAdminSuccess(response))
    .catch(error => getFileAdminError(error))),
)

// For Admin Panel - Getting file and pushing into array
const getFileAndAppendAdminEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_FILE_AND_APPEND_ADMIN),
  mergeMap(action => fileApi.getFileAdminApi(api, action.payload.id)
    .then(response => getFileAndAppendAdminSuccess(response))
    .catch(error => getFileAndAppendAdminError(error))),
)

// For Users - Getting file and pushing into array
const getFileAndAppendUserEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_FILE_AND_APPEND_USER),
  mergeMap(action => fileApi.getFileApi(api, action.payload.id)
    .then(response => getFileAndAppendUserSuccess(response))
    .catch(error => getFileAndAppendUserError(error))),
)

// eslint-disable-next-line no-unused-vars
const uploadFilesAdminEpic = (action$, state$) => action$.pipe(
  ofType(UPLOAD_FILES_ADMIN),
  mergeMap(action => fileApi.uploadFilesApi(action.payload.data, action.payload.resUrl, action.payload.dataType)
    .then(response => uploadFilesAdminSuccess(response))
    .catch(error => uploadFilesAdminError(error))),
)

const getUploadFilesUrlAdminEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_FILES_URL_ADMIN),
  mergeMap(action => fileApi.getFilesUploadURLAdminApi(api, action.payload.data)
    .then(response => getUploadFilesUrlAdminSuccess(response.data))
    .catch(error => getUploadFilesUrlAdminError(error))),
)

const getFileEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_FILE),
  mergeMap(action => fileApi.getFileApi(api, action.payload.id)
    .then(response => getFileSuccess(response))
    .catch(error => getFileError(error))),
)

// Use-case -> when needs to get file on multiple places in same component
const getFileTwoEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_FILE_TWO),
  mergeMap(action => fileApi.getFileApi(api, action.payload.id)
    .then(response => getFileTwoSuccess(response))
    .catch(error => getFileTwoError(error))),
)

const getMultipleFileEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_MULTIPLE_FILE),
  mergeMap(action => fileApi.getMultipleFileApi(api, action.payload.idsArray)
    .then(response => getMultipleFileSuccess(response.data))
    .catch(error => getMultipleFileError(error))),
)

// eslint-disable-next-line no-unused-vars
const uploadFilesEpic = (action$, state$) => action$.pipe(
  ofType(UPLOAD_FILES),
  mergeMap(action => fileApi.uploadFilesApi(action.payload.data, action.payload.resUrl, action.payload.dataType)
    .then(response => uploadFilesSuccess(response))
    .catch(error => uploadFilesError(error))),
)

const getUploadFilesUrlEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_FILES_URL),
  mergeMap(action => fileApi.getFilesUploadURLApi(api, action.payload.data)
    .then(response => getUploadFilesUrlSuccess(response.data))
    .catch(error => getUploadFilesUrlError(error))),
)

const getMCFileEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_MC_FILE),
  mergeMap(action => fileApi.getFileApi(api, action.payload.id)
    .then(response => getMCFileSuccess(response))
    .catch(error => getMCFileError(error))),
)

const getReferralFileEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_REFERRAL_FILE),
  mergeMap(action => fileApi.getFileApi(api, action.payload.id)
    .then(response => getReferralFileSuccess(response))
    .catch(error => getReferralFileError(error))),
)

const getPrescriptionFileEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PRESCRIPTION_FILE),
  mergeMap(action => fileApi.getFileApi(api, action.payload.id)
    .then(response => getPrescriptionFileSuccess(response))
    .catch(error => getPrescriptionFileError(error))),
)

module.exports = {
  // For Admin Panel
  getFileAdminEpic,
  // For Admin Panel - Getting file and pushing into array
  getFileAndAppendAdminEpic,
  // For Users - Getting file and pushing into array
  getFileAndAppendUserEpic,
  uploadFilesAdminEpic,
  getUploadFilesUrlAdminEpic,

  getFileEpic,
  // Use-case -> when needs to get file on multiple places in same component
  getFileTwoEpic,
  getMultipleFileEpic,
  uploadFilesEpic,
  getUploadFilesUrlEpic,
  getMCFileEpic,
  getReferralFileEpic,
  getPrescriptionFileEpic,
}
